document.addEventListener("DOMContentLoaded", function () {

    jQuery("#gform_1").hide();

    const meterQty = document.getElementById("meterQty");

    if (meterQty) {
        meterQty.addEventListener("change", function () {
            if (this.value !== "" && Number(this.value) < 10) {
                this.value = 10;
            }
        });
    }

    jQuery(".enquire-btn").on("click", function () {

        jQuery(".meter-calculator").hide();
        jQuery("#gform_1").show();

        const selectedText =
            jQuery(this).closest(".card").find("h5").text() +
            " - Qty: " +
            jQuery("#meterQty").val();

        jQuery("#input_1_7").val(selectedText);

    });

    const $container = jQuery("#meterQtyContainer");

    if ($container.length) {

        const originalTop = $container.offset().top;

        jQuery(window).on("scroll resize", function () {

            const scrollTop = jQuery(window).scrollTop();

            const triggerPoint =
                scrollTop + (jQuery(window).height() * 0.5);

            if (triggerPoint > originalTop) {
                $container.addClass("fixed");
            } else {
                $container.removeClass("fixed");
            }

        });

    }

});